export const environment = {
  production: true,
  basicAuthClientID: 'client',
  basicAuthSecret: 'z5dbimtOoFxcFTfK7at3',
  isAnalyticsEnabled: true,
  g_analytics_id: 'G-XLVY17JHSJ',
  authServiceBaseUrl: 'https://auth.oasis-s4-prod.apis.tessco.com/',
  approvalServiceBaseUrl: 'https://project.oasis-s4-prod.apis.tessco.com/',
  commentServiceBaseUrl: 'https://comments.oasis-s4-prod.apis.tessco.com/',
  fileServiceBaseUrl: 'https://file.oasis-s4-prod.apis.tessco.com/',
  marketServiceBaseUrl: 'https://market.oasis-s4-prod.apis.tessco.com/',
  notificationServiceBaseUrl: 'https://notification.oasis-s4-prod.apis.tessco.com/',
  preferenceServiceBaseUrl: 'https://preference.oasis-s4-prod.apis.tessco.com/',
  productAliasServiceBaseUrl: 'https://product-alias.oasis-s4-prod.apis.tessco.com/',
  projectServiceBaseUrl: 'https://project.oasis-s4-prod.apis.tessco.com/',
  userServiceBaseUrl: 'https://user.oasis-s4-prod.apis.tessco.com/',
  searchServiceBaseUrl: 'https://search.oasis-s4-prod.apis.tessco.com/',
  tesscoProxyServiceBaseUrl: 'https://tessco-proxy.oasis-s4-prod.apis.tessco.com/',
  tasksServiceBaseUrl: 'https://tasks.oasis-s4-prod.apis.tessco.com/',
  reportServiceBaserUrl: 'https://reports.oasis-s4-prod.apis.tessco.com/'
};


// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/environments/environment.ts